import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Program, ProgramWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreateProgram(): UseMutationResult<
  AxiosResponse<Program>,
  AxiosError<ErrorMessage>,
  ProgramWrite
> {
  const queryClient = useQueryClient();

  const createProgram = useCallback((program: ProgramWrite): Promise<AxiosResponse<Program>> => {
    return client.post('programs/', program);
  }, []);

  return useMutation(createProgram, {
    onSuccess: () => {
      queryClient.invalidateQueries('programs');
    },
  });
}
